var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "window",
      attrs: { id: "sign-in", role: "tabpanel", "aria-label": "Sign-in" },
    },
    [
      _c(
        "form",
        {
          staticClass: "container",
          attrs: { method: "post", action: "" },
          on: { submit: _vm.onSubmit },
        },
        [
          _c("img", {
            staticClass: "logo",
            attrs: {
              src: "img/logo-vertical-transparent-bg.svg",
              alt: "The Lounge",
              width: "256",
              height: "170",
            },
          }),
          _c("img", {
            staticClass: "logo-inverted",
            attrs: {
              src: "img/logo-vertical-transparent-bg-inverted.svg",
              alt: "The Lounge",
              width: "256",
              height: "170",
            },
          }),
          _c("label", { attrs: { for: "signin-username" } }, [
            _vm._v("Username"),
          ]),
          _c("input", {
            ref: "username",
            staticClass: "input",
            attrs: {
              id: "signin-username",
              type: "text",
              name: "username",
              autocapitalize: "none",
              autocorrect: "off",
              autocomplete: "username",
              required: "",
              autofocus: "",
            },
            domProps: { value: _vm.getStoredUser() },
          }),
          _c(
            "div",
            { staticClass: "password-container" },
            [
              _c("label", { attrs: { for: "signin-password" } }, [
                _vm._v("Password"),
              ]),
              _c("RevealPassword", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (slotProps) {
                      return [
                        _c("input", {
                          ref: "password",
                          staticClass: "input",
                          attrs: {
                            id: "signin-password",
                            type: slotProps.isVisible ? "text" : "password",
                            name: "password",
                            autocapitalize: "none",
                            autocorrect: "off",
                            autocomplete: "current-password",
                            required: "",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.errorShown
            ? _c("div", { staticClass: "error" }, [
                _vm._v("Authentication failed."),
              ])
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "btn",
              attrs: { disabled: _vm.inFlight, type: "submit" },
            },
            [_vm._v("Sign in")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }